export const AWS_REGION = 'us-east-1';
export const AWS_APPSYNC_ENDPOINT_URL = process.env.APPSYNC_ENDPOINT || 'https://jz6edp4dyve7fch7zuejf7inb4.appsync-api.us-east-1.amazonaws.com/graphql';
